import { Banner } from "../Model/Banner";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";


export interface GetBannerByIdUseCase {
  invoke: (id: number) => Promise<Banner | null>;
}

export class GetBannerById implements GetBannerByIdUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(id: number){
    if(!id){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.Repo.getBannerById(id);
    return getData;
  }
}